"use server";

import { prisma } from "@/lib/prisma";

export type LeadState = { ok?: true; error?: string } | undefined;

function cleanEmail(v: FormDataEntryValue | null) {
  return String(v ?? "").trim().toLowerCase();
}

// /apply — founding-access application. Captured as a Waitlist lead.
export async function applyAction(
  _prev: LeadState,
  formData: FormData,
): Promise<LeadState> {
  const email = cleanEmail(formData.get("email"));
  const name = String(formData.get("full_name") ?? "").trim();
  const business = String(formData.get("business_name") ?? "").trim();
  if (!email || !email.includes("@")) return { error: "Enter a valid email." };
  if (!name) return { error: "Enter your name." };
  if (!business) return { error: "Enter your business name." };
  const budget = String(formData.get("budget") ?? "").trim() || null;
  const categories = String(formData.get("categories") ?? "").trim() || null;
  const channels = String(formData.get("sales_channels") ?? "").trim() || null;
  const message = String(formData.get("message") ?? "").trim() || null;
  const data = { name, business, budget, categories, channels, message };
  try {
    await prisma.waitlist.upsert({
      where: { email },
      create: { email, ...data },
      update: data,
    });
  } catch {
    return { error: "Something went wrong. Please try again." };
  }
  return { ok: true };
}

// /contact: general "Get in Touch" inquiry. Logged as a ContactSubmission so
// the admin console sees every message (with its subject) in full.
export async function contactAction(
  _prev: LeadState,
  formData: FormData,
): Promise<LeadState> {
  const email = cleanEmail(formData.get("email"));
  const name = String(formData.get("name") ?? "").trim();
  const subject = String(formData.get("subject") ?? "").trim() || null;
  const message = String(formData.get("message") ?? "").trim();
  if (!name) return { error: "Enter your name." };
  if (!email || !email.includes("@")) return { error: "Enter a valid email." };
  if (!message) return { error: "Enter a message." };
  try {
    await prisma.contactSubmission.create({
      data: { name, email, subject, message },
    });
  } catch {
    return { error: "Something went wrong. Please try again." };
  }
  return { ok: true };
}
